import { useEffect } from 'react';
import { useRevealOnScroll } from '@/hooks/useScrollReveal';
import { Link } from 'react-router-dom';

const services = [
  { icon: 'ri-flight-takeoff-line', title: 'Express Kurye Servisi', href: '/hizmetler' },
  { icon: 'ri-store-2-line', title: 'Uluslararası E-Ticaret', href: '/hizmetler' },
  { icon: 'ri-ship-line', title: 'Kargo Taşımacılığı', href: '/hizmetler' },
  { icon: 'ri-archive-2-line', title: 'Fulfillment', href: '/hizmetler' },
  { icon: 'ri-shopping-bag-line', title: 'Online Mağaza', href: '/hizmetler' },
  { icon: 'ri-file-text-line', title: 'A.TR Belgesi', href: '/hizmetler' },
  { icon: 'ri-global-line', title: 'Mikro İhracat – ETGB', href: '/hizmetler' },
  { icon: 'ri-user-star-line', title: 'On Board Kurye Servisi', href: '/hizmetler' },
  { icon: 'ri-shield-check-line', title: 'Sigorta', href: '/hizmetler' },
];

const values = [
  { icon: 'ri-focus-3-line', title: 'Müşteri Odaklılık', desc: 'Her kararımızı müşteri memnuniyetini merkeze alarak veriyoruz. Çözüm üretmek, sorun değil.' },
  { icon: 'ri-rocket-line', title: 'Hız & Güvenlik', desc: 'En uzun mesafeleri kısaltarak gönderilerinizi en kısa sürede, maksimum güvenlikte teslim ediyoruz.' },
  { icon: 'ri-lightbulb-line', title: 'İnovatif Çözümler', desc: 'Son teknolojik sistem ve uygulamaları yakından takip ediyor, müşterilerimizi bu yönde destekliyoruz.' },
  { icon: 'ri-price-tag-3-line', title: 'Uygun Fiyat', desc: 'En uygun fiyatlarla kaliteli hizmet sunmak temel prensiplerimizden biridir.' },
];

const stats = [
  { value: '220+', label: 'Ülkeye Teslimat' },
  { value: '6.090+', label: 'Aylık Gönderi' },
  { value: '3.220+', label: 'Fulfillment Dağıtımı' },
  { value: '9', label: 'Farklı Hizmet' },
];

export default function AboutPage() {
  useRevealOnScroll();
  useEffect(() => {
    document.title = 'Hakkımızda | CargoNet – Yurtdışı Kargo & Lojistik Uzmanı';
    window.scrollTo(0, 0);
  }, []);

  return (
    <main style={{ background: 'var(--bg)', color: 'var(--text1)' }}>

      {/* ── HERO ── */}
      <section className="relative pt-36 pb-24 overflow-hidden" style={{ background: 'var(--bg)' }}>
        <div className="absolute inset-0 pointer-events-none">
          <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(var(--dot-color) 1px, transparent 1px)', backgroundSize: '40px 40px' }} />
          <div style={{ position: 'absolute', top: '-200px', right: '-150px', width: 600, height: 600, background: 'radial-gradient(circle, var(--glow2) 0%, transparent 65%)', borderRadius: '50%' }} />
          <div style={{ position: 'absolute', bottom: 0, left: '-20%', right: '-20%', height: '40%', backgroundImage: 'linear-gradient(var(--grid-color) 1px, transparent 1px), linear-gradient(90deg, var(--grid-color) 1px, transparent 1px)', backgroundSize: '50px 50px', transform: 'perspective(600px) rotateX(62deg)', transformOrigin: 'bottom', maskImage: 'linear-gradient(to top, rgba(0,0,0,0.5) 0%, transparent 80%)', WebkitMaskImage: 'linear-gradient(to top, rgba(0,0,0,0.5) 0%, transparent 80%)' }} />
        </div>
        <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <div className="label"><div className="label-dot" />Hakkımızda</div>
              <h1
                className="h-font leading-[0.95] mb-6"
                style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(46px,6vw,80px)', color: 'var(--text1)' }}
              >
                CargoNet<br /><span className="text-gradient">Lojistik</span>
              </h1>
              <p style={{ fontSize: 18, color: 'var(--text2)', maxWidth: 500, lineHeight: 1.8, marginBottom: 12 }}>
                <strong style={{ color: 'var(--text1)' }}>220&apos;yi aşkın ülkeye</strong> gönderilerinizi en kısa sürede, maksimum güvenlikte, en uygun fiyatlarla taşıyoruz.
              </p>
              <p style={{ fontSize: 16, color: 'var(--text2)', maxWidth: 500, lineHeight: 1.75, marginBottom: 36 }}>
                E-ihracattaki deneyimli kadromuz, ekspress kurye ve kargo taşımacılığındaki inovatif çözümlerimiz ile müşterilerimizi tüm dünya ile tanıştırıyoruz.
              </p>
              <div className="flex flex-wrap gap-3">
                <Link to="/hizmetler" className="btn-primary cursor-pointer">
                  Hizmetlerimiz <i className="ri-arrow-right-line bounce-x" />
                </Link>
                <Link to="/iletisim" className="btn-ghost cursor-pointer">
                  İletişime Geç
                </Link>
              </div>
            </div>
            <div className="reveal-r relative" style={{ paddingBottom: 24, paddingRight: 16 }}>
              {/* Glow behind */}
              <div style={{ position: 'absolute', inset: '-30px', background: 'radial-gradient(ellipse at 60% 40%, rgba(232,97,26,0.18) 0%, transparent 65%)', filter: 'blur(24px)', borderRadius: 32, zIndex: 0 }} />

              <div className="relative rounded-3xl overflow-hidden grad-border" style={{ aspectRatio: '4/3', zIndex: 1 }}>
                <img
                  src="https://readdy.ai/api/search-image?query=aerial%20night%20view%20of%20cargo%20airplane%20flying%20over%20illuminated%20city%20lights%20with%20orange%20engine%20glow%20dramatic%20dark%20sky%20cinematic%20professional%20aviation%20photography%20long%20exposure&width=700&height=530&seq=about-hero-plane-v2&orientation=landscape"
                  alt="CargoNet Lojistik – Dünyaya Uçuyor"
                  className="w-full h-full object-cover object-top"
                />
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg, rgba(6,9,18,0.55) 0%, transparent 55%)' }} />
                {/* Scan line */}
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: 'linear-gradient(90deg, transparent, rgba(232,97,26,0.6), transparent)', animation: 'scan 3s linear infinite' }} />
              </div>

              {/* Badge bottom-left */}
              <div
                className="glass absolute flex items-center gap-3 px-4 py-3 rounded-2xl float-y"
                style={{ bottom: 8, left: -16, boxShadow: '0 8px 40px rgba(0,0,0,0.35)', zIndex: 5 }}
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-xl" style={{ background: 'rgba(232,97,26,0.2)', border: '1px solid rgba(232,97,26,0.35)' }}>
                  <i className="ri-global-line text-[#E8611A]" />
                </div>
                <div>
                  <div style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 20, color: 'var(--text1)', lineHeight: 1 }}>220+ Ülke</div>
                  <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 2 }}>Teslimat Ağı</div>
                </div>
              </div>

              {/* Badge top-right */}
              <div
                className="glass absolute flex items-center gap-3 px-4 py-3 rounded-2xl float-y2"
                style={{ top: -16, right: -8, boxShadow: '0 8px 40px rgba(0,0,0,0.35)', zIndex: 5 }}
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-xl" style={{ background: 'rgba(34,197,94,0.18)', border: '1px solid rgba(34,197,94,0.3)' }}>
                  <i className="ri-flight-takeoff-line text-green-400" />
                </div>
                <div>
                  <div style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 14, color: 'var(--text1)', lineHeight: 1 }}>Ekspres Teslimat</div>
                  <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 2 }}>24–72 saat • 7/24 aktif</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── STATS ── */}
      <section style={{ background: 'var(--bg2)', borderTop: '1px solid var(--border)', borderBottom: '1px solid var(--border)', padding: '56px 0' }}>
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
            {stats.map((s, i) => (
              <div key={i} className={`reveal d${i + 1} text-center`}>
                <div style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(32px,4vw,52px)', color: 'var(--orange)', lineHeight: 1, marginBottom: 8 }}>{s.value}</div>
                <div style={{ fontSize: 14, color: 'var(--text2)', fontWeight: 500 }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── ABOUT TEXT ── */}
      <section style={{ background: 'var(--bg)', padding: '96px 0', borderBottom: '1px solid var(--border)' }}>
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <div className="label"><div className="label-dot" />Biz Kimiz</div>
              <h2
                className="reveal h-font leading-[1.1] mb-6"
                style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(36px,4.5vw,52px)', color: 'var(--text1)' }}
              >
                Dünyaya açılan<br /><span className="text-gradient">lojistik köprünüz.</span>
              </h2>
              <p className="reveal d2 text-base leading-relaxed mb-5" style={{ color: 'var(--text2)' }}>
                CargoNet olarak, 220&apos;yi aşkın ülkeye gönderilerinizi en kısa sürede, maksimum güvenlikte, en uygun fiyatlarla taşıyoruz.
              </p>
              <p className="reveal d3 text-base leading-relaxed mb-5" style={{ color: 'var(--text2)' }}>
                E-ihracattaki deneyimli kadromuz, ekspress kurye ve kargo taşımacılığındaki inovatif çözümlerimiz ile müşterilerimizi tüm dünya ile tanıştırıyoruz. Ayrıca son teknolojik sistem ve uygulamaları yakından takip ediyor ve müşterilerimizi bu yönde destekliyoruz.
              </p>
              <p className="reveal d4 text-base leading-relaxed" style={{ color: 'var(--text2)' }}>
                En uzun mesafeleri kısaltarak gönderilerinizi en kısa sürede teslim etmeyi hedefliyoruz.
              </p>
            </div>
            <div className="reveal-r flex flex-col gap-5">
              {/* Visual card */}
              <div className="relative rounded-3xl overflow-hidden grad-border" style={{ height: 220 }}>
                <img
                  src="https://readdy.ai/api/search-image?query=modern%20logistics%20warehouse%20interior%20with%20conveyor%20belts%20packages%20moving%20orange%20accent%20lighting%20dark%20industrial%20professional%20wide%20angle%20photography%20cinematic%20depth%20of%20field&width=700&height=220&seq=about-warehouse-v2&orientation=landscape"
                  alt="CargoNet Fulfillment Merkezi"
                  className="w-full h-full object-cover"
                />
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(6,9,18,0.75) 0%, transparent 50%)' }} />
                <div className="absolute bottom-4 left-5">
                  <div style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 18, color: '#fff', marginBottom: 2 }}>Fulfillment Merkezi</div>
                  <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)' }}>Esenyurt, İstanbul • 5.000 m²</div>
                </div>
                <div className="absolute top-4 right-4 flex items-center gap-1.5 px-3 py-1.5 rounded-full" style={{ background: 'rgba(34,197,94,0.2)', border: '1px solid rgba(34,197,94,0.35)' }}>
                  <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse inline-block" />
                  <span style={{ fontSize: 11, fontWeight: 700, color: '#4ade80' }}>Aktif</span>
                </div>
              </div>

              <div
                className="rounded-3xl p-8"
                style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}
              >
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl" style={{ background: 'rgba(232,97,26,0.12)', border: '1px solid rgba(232,97,26,0.2)' }}>
                    <i className="ri-map-pin-2-line text-[#E8611A]" />
                  </div>
                  <div style={{ fontWeight: 800, fontSize: 16, color: 'var(--text1)' }}>İletişim Bilgileri</div>
                </div>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <i className="ri-map-pin-line text-[#E8611A] mt-0.5 flex-shrink-0" />
                    <div>
                      <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 2 }}>Adres</div>
                      <div style={{ fontSize: 14, color: 'var(--text2)', lineHeight: 1.6 }}>Turgut Özal Mah. 55.Sk. No:47/3<br />Esenyurt / İSTANBUL</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-phone-line text-[#E8611A] mt-0.5 flex-shrink-0" />
                    <div>
                      <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 2 }}>Destek Hattı</div>
                      <a href="tel:+908502420822" style={{ fontSize: 14, color: 'var(--text2)', textDecoration: 'none' }}>0850 242 0 822</a>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-whatsapp-line text-green-500 mt-0.5 flex-shrink-0" />
                    <div>
                      <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 2 }}>WhatsApp</div>
                      <a href="https://wa.me/905058916367" rel="nofollow" style={{ fontSize: 14, color: 'var(--text2)', textDecoration: 'none' }}>0505 891 6 367</a>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-mail-line text-[#E8611A] mt-0.5 flex-shrink-0" />
                    <div>
                      <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 2 }}>E-posta</div>
                      <a href="mailto:cs@cargonet.com.tr" style={{ fontSize: 14, color: 'var(--text2)', textDecoration: 'none' }}>cs@cargonet.com.tr</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── SERVICES ── */}
      <section style={{ background: 'var(--bg2)', padding: '96px 0', borderBottom: '1px solid var(--border)' }}>
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            <div>
              <div className="label"><div className="label-dot" />Hizmetlerimiz</div>
              <h2
                className="reveal h-font leading-[1.1] mb-5"
                style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(36px,4.5vw,52px)', color: 'var(--text1)' }}
              >
                Tüm Hizmetlerimizle<br /><span className="text-gradient">Yanınızdayız!</span>
              </h2>
              <p className="reveal d2 mb-8" style={{ fontSize: 16, color: 'var(--text2)', lineHeight: 1.75 }}>
                Diğer hizmetlerimiz için İletişim bölümünden bize yazabilirsiniz. Uzman ekibimiz size en uygun çözümü sunmak için hazır.
              </p>
              <Link to="/iletisim" className="reveal d3 btn-primary cursor-pointer">
                İletişime Geç <i className="ri-arrow-right-line bounce-x" />
              </Link>
            </div>
            <div className="grid grid-cols-1 gap-2">
              {services.map((svc, i) => (
                <Link
                  key={i}
                  to={svc.href}
                  className={`reveal d${Math.min(i + 1, 6)} flex items-center gap-4 p-4 rounded-2xl cursor-pointer transition-all duration-300`}
                  style={{ background: 'var(--surface)', border: '1px solid var(--border)', textDecoration: 'none' }}
                  onMouseEnter={(e) => {
                    (e.currentTarget as HTMLElement).style.background = 'rgba(232,97,26,0.07)';
                    (e.currentTarget as HTMLElement).style.borderColor = 'rgba(232,97,26,0.25)';
                  }}
                  onMouseLeave={(e) => {
                    (e.currentTarget as HTMLElement).style.background = 'var(--surface)';
                    (e.currentTarget as HTMLElement).style.borderColor = 'var(--border)';
                  }}
                >
                  <div
                    className="w-9 h-9 flex items-center justify-center rounded-xl flex-shrink-0"
                    style={{ background: 'rgba(232,97,26,0.12)', border: '1px solid rgba(232,97,26,0.2)' }}
                  >
                    <i className={`${svc.icon} text-[#E8611A]`} />
                  </div>
                  <span style={{ fontSize: 14, fontWeight: 600, color: 'var(--text1)' }}>{svc.title}</span>
                  <i className="ri-arrow-right-s-line ml-auto text-[#E8611A]" />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── VALUES ── */}
      <section style={{ background: 'var(--bg)', padding: '96px 0', borderBottom: '1px solid var(--border)' }}>
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="text-center max-w-xl mx-auto mb-16">
            <div className="label inline-flex"><div className="label-dot" />Neden CargoNet?</div>
            <h2
              className="reveal h-font leading-[1.1]"
              style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(36px,4.5vw,52px)', color: 'var(--text1)' }}
            >
              Bizi tercih etmeniz için<br /><span className="text-gradient">4 güçlü neden</span>
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {values.map((v, i) => (
              <div key={i} className={`reveal d${i + 1} card-dark p-8`}>
                <div
                  className="w-12 h-12 flex items-center justify-center rounded-2xl mb-5"
                  style={{ background: 'rgba(232,97,26,0.12)', border: '1px solid rgba(232,97,26,0.2)' }}
                >
                  <i className={`${v.icon} text-[#E8611A] text-xl`} />
                </div>
                <h3 style={{ fontWeight: 800, fontSize: 16, color: 'var(--text1)', marginBottom: 10 }}>{v.title}</h3>
                <p style={{ fontSize: 14, color: 'var(--text2)', lineHeight: 1.7 }}>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section style={{ background: 'var(--bg2)', padding: '80px 20px', borderTop: '1px solid var(--border)' }}>
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div
            className="rounded-3xl p-12 text-center relative overflow-hidden"
            style={{ background: 'var(--surface)', border: '1px solid var(--border2)' }}
          >
            <div style={{ position: 'absolute', top: '-100px', left: '50%', transform: 'translateX(-50%)', width: 400, height: 400, background: 'radial-gradient(circle, var(--glow2) 0%, transparent 65%)', borderRadius: '50%', pointerEvents: 'none' }} />
            <div className="relative">
              <div className="label inline-flex mb-6"><div className="label-dot" />Hemen Başlayın</div>
              <h2
                style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(28px,4vw,48px)', color: 'var(--text1)', marginBottom: 16 }}
              >
                Size ulaşmamız için<br />iletişim bilgilerinizi bırakın.
              </h2>
              <p style={{ fontSize: 17, color: 'var(--text2)', maxWidth: 480, margin: '0 auto 36px', lineHeight: 1.7 }}>
                Ücretsiz danışmanlık için ekibimizle iletişime geçin. 24 saat içinde size dönüş yapıyoruz.
              </p>
              <div className="flex flex-wrap gap-3 justify-center">
                <Link to="/iletisim" className="btn-primary cursor-pointer">
                  İletişim <i className="ri-arrow-right-line bounce-x" />
                </Link>
                <Link to="/hizmetler" className="btn-ghost cursor-pointer">
                  Hizmetleri İncele
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

    </main>
  );
}
